import FadeLoader from 'react-spinners/FadeLoader';

function LoadingOverlay() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Ensures the container takes the full height of the viewport
      }}
    >
      <FadeLoader
        color="#fff"
        height={13}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}
//className="loading-overlay"
export default LoadingOverlay;
